


import React, { useState, useEffect, useRef } from 'react';
import BarChartIcon from "@mui/icons-material/BarChart";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import SecurityIcon from "@mui/icons-material/Security";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import fileUploadIcon from "../icon/files_upload.png";
import applicationScoreIcon from "../icon/appn.png";
import financialScoreIcon from "../icon/ruppee.png";
import verificationIcon from "../icon/verifiication.png";
import bureauScoreIcon from "../icon/bureau.png";
import lowRiskIcon from "../icon/overall.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DonutLargeIcon from "@mui/icons-material/DonutLarge";
import StatsCards from './StatCards';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Avatar,
  LinearProgress,
  IconButton,
  Checkbox,
  Typography,
  Box,
  Pagination,
  Select,
  MenuItem,
  FormControl,
  InputAdornment,
  TextField,
  InputLabel,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  ListItemButton,
  Popper,
  ClickAwayListener,
  Fab,
  Divider,
  Collapse
} from '@mui/material';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import dayjs from "dayjs";
import {
  Visibility,
  Search,
  FilterList,
  DateRange,
  Add,
  CalendarMonth,
  CloudUpload,
  Cancel,
  CheckCircle,
  Upload,
  Close,
  ArrowDropDown,
  KeyboardArrowDown,
} from '@mui/icons-material';
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { useNavigate } from 'react-router-dom';

import approve from '../icon/complete.svg';
import inprogress from '../icon/progress.svg';

//15/12
import { getAllApplications, uploadFolder as uploadFolderApi, getApplicationBlobInfo ,getDropdownOptions } from "../api";
import { getUser } from '../services/authService';

// DatePicker fallback component
const DatePickerFallback = ({ label, value, onChange, ...props }) => {
  return (
    <TextField
      label={label}
      type="date"
      size="small"
      value={value}
      onChange={onChange}
      InputLabelProps={{ shrink: true }}
      {...props}
    />
  );
};

// Helper: convert ISO (YYYY-MM-DD) to D/M/YYYY to match mock data
const formatISOToDMY = (isoDateStr) => {
  if (!isoDateStr) return '';
  // Remove timezone by using ISO date split
  return isoDateStr.split('T')[0]; // Returns YYYY-MM-DD format
};

// Helper: format amount to Indian numbering system like "INR 3,00,00,000/-"
const formatToIndianCurrency = (amountStr) => {
  if (!amountStr) return '';
  // Extract digits
  const digits = String(amountStr).replace(/[^0-9]/g, '');
  if (!digits) return amountStr;
  // Apply Indian grouping: last 3, then pairs of 2
  const lastThree = digits.slice(-3);
  const otherNumbers = digits.slice(0, -3);
  const withCommas = otherNumbers
    ? otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree
    : lastThree;
  return `INR ${withCommas}/-`;
};

// NEW CODE - ADD THIS:
const parseDate = (dateStr) => {
  if (!dateStr) return null;
  // Handle YYYY-MM-DD format (from database)
  if (dateStr.includes('-')) {
    return new Date(dateStr);
  }
  // Handle D/M/YYYY or DD/MM/YYYY format
  const [d, m, y] = dateStr.split('/').map(Number);
  if (!d || !m || !y) return null;
  return new Date(y, m - 1, d);
};

const Home = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selected, setSelected] = useState([]);
  const [filters, setFilters] = useState({
    applicationNo: '',
    borrowerName: '',
    loanType: '',
    facilityAmount: '',
    status: [],
    // status: ["Approved", "Onboarding", "Rejected", "Processing"],
    startDate: '',
    endDate: ''
  });
  const [expandedRow, setExpandedRow] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});
  const [currentUploadIndex, setCurrentUploadIndex] = useState(-1);
  const [showCompletionUI, setShowCompletionUI] = useState(false);
  const [completionProgress, setCompletionProgress] = useState(0);
  const [showSuccessUI, setShowSuccessUI] = useState(false);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [selectedRowProgress, setSelectedRowProgress] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openDateRange, setOpenDateRange] = useState(false);

  const [folderName, setFolderName] = useState('');
  //15/12

  const [statsFilterApplied, setStatsFilterApplied] = useState(false);

  // New state for dropdown functionality
  const [applicationNoOptions, setApplicationNoOptions] = useState([]);
  const [borrowerNameOptions, setBorrowerNameOptions] = useState([]);
  const [loanTypeOptions, setLoanTypeOptions] = useState([]);
  const [openApplicationNoDropdown, setOpenApplicationNoDropdown] = useState(false);
  const [openBorrowerNameDropdown, setOpenBorrowerNameDropdown] = useState(false);
  const applicationNoRef = useRef(null);
  const borrowerNameRef = useRef(null);
  const tableContainerRef = useRef(null);
  const dateRangeRef = useRef(null);
  const [value, setValue] = useState([
    filters.startDate ? dayjs(filters.startDate) : null,
    filters.endDate ? dayjs(filters.endDate) : null,
  ]);

  // Inside Home component, add this handler function 11/12 or 15/12


const handleStatsFilterChange = (filterData) => {
  console.log(' Stats card clicked:', filterData);
  setStatsFilterApplied(true);
  
  //  ALWAYS include Processing for "Total" cards
  let statusFilter = [];
  
  if (filterData.status && filterData.status.includes("Approved") && filterData.status.length === 1) {
    // Only "Approved" card was clicked
    statusFilter = ["Approved"];
  } else {
    // "Total" card was clicked - show ALL statuses including Processing
    statusFilter = ["Approved", "Onboarding", "Rejected", "Processing"];
  }
  
  // CRITICAL FIX: Clear all other filters when stats card is clicked
  setFilters({
    applicationNo: '',
    borrowerName: '',
    loanType: '',
    facilityAmount: '',
    startDate: filterData.startDate,
    endDate: filterData.endDate,
    status: statusFilter
  });
  
  // Update the date range picker value
  setValue([
    filterData.startDate ? dayjs(filterData.startDate) : null,
    filterData.endDate ? dayjs(filterData.endDate) : null,
  ]);
  
  setPage(1);
  
  console.log(' Filters applied:', {
    dateRange: `${filterData.startDate} to ${filterData.endDate}`,
    status: statusFilter,
    clearedOtherFilters: true
  });
};

  useEffect(() => {
    setValue([
      filters.startDate ? dayjs(filters.startDate) : null,
      filters.endDate ? dayjs(filters.endDate) : null,
    ]);
  }, [filters.startDate, filters.endDate]);

  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [serverPagination, setServerPagination] = useState({ totalPages: 0, totalRecords: 0 });
  const [refreshKey, setRefreshKey] = useState(0);
  const lastRefreshRef = useRef(0);

  const [validationErrors, setValidationErrors] = useState([]);
const [showValidationDialog, setShowValidationDialog] = useState(false);
  useEffect(() => {
    const bump = () => setRefreshKey((k) => k + 1);

    const applyPatches = () => {
      try {
        const patches = JSON.parse(sessionStorage.getItem('HOME_VER_PATCHES') || '{}') || {};
        if (patches && Object.keys(patches).length) {
          setApplications((prev) => prev.map((app) => {
            const patched = patches[app.id];
            return patched
              ? { ...app, expandableData: { ...(app.expandableData || {}), verification: patched } }
              : app;
          }));
        }
      } catch (_) {}
    };

    const triggerRefresh = () => {
      applyPatches();
      bump();
      // second pass to cover blob eventual consistency when update was external (e.g., Postman)
      setTimeout(() => bump(), 900);
    };

    const onStorage = (e) => {
      if (e.key === 'HOME_REFRESH') {
        lastRefreshRef.current = Number(e.newValue) || Date.now();
        triggerRefresh();
      }
    };
    const onFocus = () => {
      const ts = Number(localStorage.getItem('HOME_REFRESH') || 0);
      if (ts && ts !== lastRefreshRef.current) {
        lastRefreshRef.current = ts;
        applyPatches();
        bump();
      }
    };
    const onCustom = () => {
      triggerRefresh();
    };

    const onVerIncrement = (e) => {
      const { id, display } = (e && e.detail) || {};
      if (!id || !display) return;
      // update UI immediately for the specific row
      setApplications((prev) => prev.map((app) => (
        app.id === id
          ? { ...app, expandableData: { ...(app.expandableData || {}), verification: display } }
          : app
      )));
      // persist patch so it survives mapping/refetch
      try {
        const raw = sessionStorage.getItem('HOME_VER_PATCHES') || '{}';
        const patches = JSON.parse(raw);
        patches[id] = display;
        sessionStorage.setItem('HOME_VER_PATCHES', JSON.stringify(patches));
      } catch (_) {}
    };

    window.addEventListener('VER_INCREMENT', onVerIncrement);
    return () => {
      window.removeEventListener('VER_INCREMENT', onVerIncrement);
    };
  }, []);

  // Live label for the input while selecting dates
  const getLiveDateRangeLabel = () => {
    const start = value?.[0];
    const end = value?.[1];
    const fmt = (d) => (d ? dayjs(d).format('MM/DD/YYYY') : '');
    if (start && end) return `${fmt(start)} – ${fmt(end)}`;
    if (start) return `From - ${fmt(start)}`;
    if (end) return `To - ${fmt(end)}`;
    return '';
  };
//11/12 or 15/12
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError(null);

    const search = [filters.applicationNo, filters.borrowerName].filter(Boolean).join(' ');
    console.log(' [API CALL] Filters:', {
    page,
    loanType: filters.loanType, //  Should log the selected value
    status: filters.status,
    search
  });

  console.log('[HOME] Making API call with filters:', {
    page,
    limit: rowsPerPage,
    status: filters.status.join(','),
    loanType: filters.loanType,
    search,
    startDate: filters.startDate,
    endDate: filters.endDate
  });

    getAllApplications(
      {
        page,
        // limit: statsFilterApplied ? rowsPerPage : 5,
         limit: rowsPerPage,
        status: filters.status.join(','),   // only if backend does NOT accept array
        loanType: filters.loanType,
        search,
          startDate: filters.startDate,  
    endDate: filters.endDate,   
      },
      { signal: controller.signal }
    )
      .then((data) => {
        // Check if aborted before processing
        if (controller.signal.aborted) return;
        
        const apps = Array.isArray(data?.applications) ? data.applications : [];

        //  DEBUG: Log raw API response
        console.log(' [HOME] Raw API Response:', data);
        console.log(' [HOME] Total applications received:', apps.length);
        console.log(' [HOME] Sample applications from API:', apps.slice(0, 3).map(app => ({
          id: app.id || app.applicationNo,
          borrowerName: app.borrowerName,
          status: app.status,
          createdAt: app.createdAt,
          createdDate: app.createdDate
        })));

        // Apply any optimistic verification patches saved by Application page
        let verPatches = {};
        try {
          verPatches = JSON.parse(sessionStorage.getItem('HOME_VER_PATCHES') || '{}') || {};
        } catch (_) {}

        const mapped = apps.map((app) => {
          const id = app.applicationNo;
          
          //  DEBUG: Log each application's verification data
          console.log(`[HOME] App ${id}:`, {
            verification: app.verification,
            expandableVerification: app.expandableData?.verification,
            totalJSONFiles: app.totalJSONFiles,
            patch: verPatches[id]
          });
          
          // First check app.verification, then verPatches, then expandableData.verification
          const verification = app.verification || verPatches[id] || (app.expandableData?.verification) || '0/0';
          
          console.log(` [HOME] App ${id} final verification: "${verification}"`);
          
          // Normalize status
          let normalizedStatus = app.status || '';
          if (normalizedStatus && typeof normalizedStatus === 'string') {
            if (normalizedStatus.toLowerCase().replace(/\s+/g, '') === 'onboarding') {
              normalizedStatus = 'On Boarding';
            } else if (normalizedStatus.toLowerCase() === 'approved') {
              normalizedStatus = 'Approved';
            } else if (normalizedStatus.toLowerCase() === 'rejected') {
              normalizedStatus = 'Rejected';
            } else if (normalizedStatus.toLowerCase() === 'processing') {
              normalizedStatus = 'Processing';
            }
          }
          
          const mappedApp = {
            id,
            createdDate: (app.createdAt || app.date) ? formatISOToDMY(app.createdAt || app.date) : '',
            borrowerName: app.borrowerName || '',
            creditMemoProgress: 100,
            status: normalizedStatus,
            typeofLoan: app.typeofLoan || '',
            facilityamount: app.facilityamount || '',
            documents: app.documents || 0,
            verification: verification,
            expandableData: {
              ...(app.expandableData || {}),
              verification: verification,
            },
          };
          
          console.log(` [HOME] Mapped app ${id}:`, {
            id: mappedApp.id,
            borrowerName: mappedApp.borrowerName,
            status: mappedApp.status,
            createdDate: mappedApp.createdDate
          });
          
          return mappedApp;
        });

        console.log(` [HOME] Total mapped applications: ${mapped.length}`);
        
        // Directly set applications from API (no localStorage)
        setApplications(mapped);
        
        setServerPagination({
          totalPages: data?.pagination?.totalPages || 0,
          totalRecords: data?.pagination?.totalRecords || 0,
        });
        setLoading(false);
      })
      .catch((e) => {
        // Silently ignore AbortError - it's expected when component unmounts or filters change
        if (e.name === 'AbortError') {
          console.log('[HOME] Request aborted (expected behavior)');
          return;
        }
        setError(e.message || 'Failed to load');
        setLoading(false);
      });

    return () => {
      controller.abort();
    };
 // NEW CODE:
}, [page, rowsPerPage, filters.status, filters.loanType, filters.applicationNo, filters.borrowerName, filters.startDate, filters.endDate, refreshKey, statsFilterApplied]);

  // Add this function with improved scrolling
  const handleToggleExpand = (id) => {
    setExpandedRow((prev) => {
      const isExpanding = prev !== id;

      if (isExpanding) {
        setTimeout(() => {
          const element = document.getElementById(`row-${id}`);
          const container = tableContainerRef.current;

          if (element && container) {
            const elementRect = element.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();

            // Check if element is near the bottom of the container
            if (elementRect.bottom > containerRect.bottom - 100) {
              element.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
              });
            }
          }
        }, 300);
      }

      return isExpanding ? id : null;
    });
  };

  // Extract unique application numbers and borrower names for dropdowns
// State to store ALL unique values (add this at the top with other states)
const [allUniqueApplicationNos, setAllUniqueApplicationNos] = useState([]);
const [allUniqueBorrowerNames, setAllUniqueBorrowerNames] = useState([]);
const [allUniqueLoanTypes, setAllUniqueLoanTypes] = useState([]);

// NEW useEffect - Fetch ALL applications once for dropdowns
// ADD THIS: Fetch only dropdown options (much faster) 15/12
useEffect(() => {
  const ctrl = new AbortController();
  
  console.log(' [HOME] Fetching dropdown options...');
  
  getDropdownOptions({ signal: ctrl.signal })
    .then((data) => {
      // Check if aborted before processing
      if (ctrl.signal.aborted) return;
      
      console.log(' [HOME] Dropdown options loaded:', {
        applicationNos: data.applicationNos?.length || 0,
        borrowerNames: data.borrowerNames?.length || 0,
        loanTypes: data.loanTypes?.length || 0
      });
      
      setAllUniqueApplicationNos(data.applicationNos || []);
      setAllUniqueBorrowerNames(data.borrowerNames || []);
      setAllUniqueLoanTypes(data.loanTypes || []);
      
      setApplicationNoOptions(data.applicationNos || []);
      setBorrowerNameOptions(data.borrowerNames || []);
      setLoanTypeOptions(data.loanTypes || []);
    })
    .catch((e) => {
      // Silently ignore AbortError - it's expected when component unmounts
      if (e.name === 'AbortError') {
        console.log('[HOME] Dropdown options request aborted (expected behavior)');
        return;
      }
      console.error(' [HOME] Failed to load dropdown options:', e);
    });
  
  return () => {
    ctrl.abort();
  };
}, []);

// FIXED useEffect for Application No filtering
useEffect(() => {
  console.log(' [APPLICATION NO FILTER] Total unique application numbers:', allUniqueApplicationNos.length);
  if (filters.applicationNo && filters.applicationNo.length >= 3) {
    // Filter from the COMPLETE list, not current page
    const filteredOptions = allUniqueApplicationNos.filter(option =>
      option.toLowerCase().includes(filters.applicationNo.toLowerCase())
    );
    setApplicationNoOptions(filteredOptions);
    setOpenApplicationNoDropdown(filteredOptions.length > 0);
  } else {
    // Reset to ALL options (not just current page)
    setApplicationNoOptions(allUniqueApplicationNos);
    setOpenApplicationNoDropdown(false);
  }
}, [filters.applicationNo, allUniqueApplicationNos]);

// FIXED useEffect for Borrower Name filtering
useEffect(() => {
  if (filters.borrowerName && filters.borrowerName.length >= 3) {
    const filteredOptions = allUniqueBorrowerNames.filter(option =>
      option.toLowerCase().includes(filters.borrowerName.toLowerCase())
    );
    setBorrowerNameOptions(filteredOptions);
    setOpenBorrowerNameDropdown(filteredOptions.length > 0);
  } else {
    setBorrowerNameOptions(allUniqueBorrowerNames);
    setOpenBorrowerNameDropdown(false);
  }
}, [filters.borrowerName, allUniqueBorrowerNames]);

// FIXED useEffect for Loan Type filtering
// 3. VERIFY your useEffect for Loan Type filtering is correct: 15/12
useEffect(() => {
  if (filters.loanType && filters.loanType.length >= 3) {
    const filteredOptions = allUniqueLoanTypes.filter(option =>
      option.toLowerCase().includes(filters.loanType.toLowerCase())
    );
    setLoanTypeOptions(filteredOptions);
    setOpenLoanTypeDropdown(filteredOptions.length > 0);
  } else {
    setLoanTypeOptions(allUniqueLoanTypes);
    setOpenLoanTypeDropdown(false);
  }
}, [filters.loanType, allUniqueLoanTypes]);

//  DEBUGGING: Add console.log to see what's happening
// Add this inside your Type of Loan TextField onChange:


  const getStatusColor = (status) => {
    switch (status) {
      case 'Approved':
        return '#5ABA85';
      case 'Rejected':
        return 'error';
      case 'Draft':
        return 'default';
      case 'Submitted':
        return '#034A7F';
      case 'In Review':
        return 'warning';
      case 'Pending Approval':
        return 'secondary';
      default:
        return 'default';
    }
  };

  const getProgressColor = (progress) => {
    if (progress === 100) return '#5ABA85';
    if (progress >= 50) return 'info';
    if (progress >= 25) return 'warning';
    return 'error';
  };

  const getDateRangeLabel = () => {
    const fromLabel = value[0] ? value[0].format('MM/DD/YY') : 'From';
    const toLabel = value[1] ? value[1].format('MM/DD/YY') : 'To';
    if (!value[0] && !value[1]) return 'Created Date';
    return `${fromLabel} - ${toLabel}`;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // REMOVE THIS LINE: setExpandedRow(null);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
    // REMOVE THIS LINE: setExpandedRow(null);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = applications.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

 const handleFilterChange = (field, value) => {
  setFilters(prev => ({ ...prev, [field]: value }));
  setPage(1);
};

 //15/12
const handleSelectOption = (field, value) => {
  console.log(' [DROPDOWN] Selected:', field, '=', value);
  
  // This triggers the API call AND resets page to 1
  handleFilterChange(field, value);
  
  // Close the appropriate dropdown
  if (field === 'applicationNo') {
    setOpenApplicationNoDropdown(false);
  } else if (field === 'borrowerName') {
    setOpenBorrowerNameDropdown(false);
  } else if (field === 'loanType') {
    setOpenLoanTypeDropdown(false);
  }
};
  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Filter data based on filter criteria (apply any remaining client-side filters)
// Replace your filteredData logic with this fixed version:
//11/12 15/12
// Filter data based on filter criteria (apply any remaining client-side filters)
const filteredData = applications.filter(item => {
  const matchesText =
    item.id?.toLowerCase().includes(filters.applicationNo.toLowerCase()) &&
    item.borrowerName?.toLowerCase().includes(filters.borrowerName.toLowerCase());

  const matchesFacility =
    filters.facilityAmount === '' ||
    formatToIndianCurrency(item.facilityamount)
      .toLowerCase()
      .includes(filters.facilityAmount.toLowerCase());

  // FIXED STATUS FILTER - Handle array of statuses
  const normalizeStatus = (status) => {
    if (!status || typeof status !== 'string') return '';
    const normalized = status.toLowerCase().replace(/\s+/g, '');
    // Map common variations
    if (normalized === 'onboarding' || normalized === 'on-boarding') return 'onboarding';
    if (normalized === 'approved') return 'approved';
    if (normalized === 'rejected') return 'rejected';
    if (normalized === 'processing') return 'processing';
    return normalized;
  };

  // Handle array of statuses (multi-select)
  const matchesStatus = 
    !Array.isArray(filters.status) || 
    filters.status.length === 0 || 
    filters.status.some(filterStatus => 
      normalizeStatus(filterStatus) === normalizeStatus(item.status)
    );

  // DATE RANGE FILTER
  const itemDate = parseDate(item.createdDate);
  let inRange = true;

  if (itemDate) {
    if (filters.startDate) {
      const start = new Date(filters.startDate);
      start.setHours(0, 0, 0, 0);
      inRange = inRange && itemDate >= start;
    }

    if (filters.endDate) {
      const end = new Date(filters.endDate);
      end.setHours(23, 59, 59, 999);
      inRange = inRange && itemDate <= end;
    }
  } else if (filters.startDate || filters.endDate) {
    inRange = false;
  }

  return (
    matchesText &&
    matchesFacility &&
    matchesStatus &&
    inRange
  );
});


  useEffect(() => {
    if (filteredData.length > 0 && !selectedRowId) {
      setSelectedRowId(filteredData[0].id);
    }
  }, [filteredData, selectedRowId]);

  // const totalPages = serverPagination.totalPages || Math.ceil(filteredData.length / rowsPerPage);
  const totalPages = serverPagination.totalPages; // Use server's total pages

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  // Handle + button click based on user role
  const handlePlusButtonClick = () => {
    const user = getUser();
    const userRoleId = user?.roleId || 1; // Default to Tenant Admin
    
    console.log(' Plus button clicked - User Role ID:', userRoleId);
    
    if (userRoleId === 2) {
      // Super Admin - Open upload modal
      console.log(' Super Admin - Opening upload modal');
      handleOpenDialog();
    } else {
      // Tenant Admin - Navigate to upload page (existing behavior)
      console.log(' Tenant Admin - Navigating to upload page');
      navigate('/upload-documents');
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    // Reset states when closing
    setTimeout(() => {
      setUploadedFiles([]);
      setIsUploading(false);
      setUploadProgress({});
      setCurrentUploadIndex(-1);
      setShowCompletionUI(false);
      setCompletionProgress(0);
      setShowSuccessUI(false);
    }, 300);
  };

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);

    // Only allow ZIP files
    const allowedFiles = files.filter(file => {
      const fileExtension = file.name.toLowerCase().split('.').pop();
      return fileExtension === 'zip';
    });

    if (allowedFiles.length === 0) {
      alert('Please upload only ZIP folder files');
      return;
    }

    if (uploadedFiles.length + allowedFiles.length > 10) {
      alert('Maximum 10 files allowed');
      return;
    }

    const newFiles = allowedFiles.map((file, index) => ({
      id: Date.now() + index,
      name: file.name,
      size: file.size,
      file: file,
      status: 'pending'
    }));

    setUploadedFiles(prev => [...prev, ...newFiles]);
  };

  const handleRemoveFile = (index) => {
    setUploadedFiles(prev => prev.filter((_, i) => i !== index));
  };

  const handleStartUpload = async () => {
    if (uploadedFiles.length === 0) return;

    // Super Admin validation (Role ID = 2)
    const user = getUser();
    const userRoleId = user?.roleId || 1; // Default to Tenant Admin
    console.log(' User Role ID:', userRoleId);
    
    if (userRoleId === 2) { // Super Admin - strict validation
      console.log(' Applying Super Admin upload validation...');
      
      // Filename normalization function (matches backend logic)
      const normalizeFileName = (originalFileName) => {
        const lower = originalFileName.toLowerCase();
        
        // Loan Application
        if (lower.includes('loan application') || lower.includes('loan_application') || lower.includes('application')) {
          return 'COM_LOAN_Application.pdf';
        }
        
        // Primary Applicant Documents
        if (lower.includes('primary') && (lower.includes('aadhaar') || lower.includes('aadhar'))) {
          return 'PR_AADHAR.pdf';
        }
        if (lower.includes('primary') && lower.includes('pan')) {
          return 'PR_PAN.pdf';
        }
        if (lower.includes('primary') && lower.includes('cibil')) {
          return 'PR_CIBIL.pdf';
        }
        if (lower.includes('primary') && (lower.includes('networth') || lower.includes('net worth'))) {
          return 'PR_NETWORTH.pdf';
        }
        if (lower.includes('primary') && lower.includes('itr') && lower.includes('2022')) {
          return 'PR_2022_ITR.pdf';
        }
        if (lower.includes('primary') && lower.includes('itr') && lower.includes('2023')) {
          return 'PR_2023_ITR.pdf';
        }
        
        // Co-Applicant Documents
        if ((lower.includes('co-applicant') || lower.includes('co applicant') || lower.includes('co1')) && (lower.includes('aadhaar') || lower.includes('aadhar'))) {
          return 'CO1_AADHAR.pdf';
        }
        if ((lower.includes('co-applicant') || lower.includes('co applicant') || lower.includes('co1')) && lower.includes('pan')) {
          return 'CO1_PAN.pdf';
        }
        if ((lower.includes('co-applicant') || lower.includes('co applicant') || lower.includes('co1')) && lower.includes('cibil')) {
          return 'CO1_CIBIL.pdf';
        }
        if ((lower.includes('co-applicant') || lower.includes('co applicant') || lower.includes('co1')) && lower.includes('itr') && lower.includes('2022')) {
          return 'CO1_2022_ITR.pdf';
        }
        if ((lower.includes('co-applicant') || lower.includes('co applicant') || lower.includes('co1')) && lower.includes('itr') && lower.includes('2023')) {
          return 'CO1_2023_ITR.pdf';
        }
        
        // Company Documents
        if (lower.includes('company') && lower.includes('cibil')) {
          return 'COM_CIBIL.pdf';
        }
        if (lower.includes('gst') && (lower.includes('certificate') || lower.includes('registration'))) {
          return 'COM_GST_Certificate.pdf';
        }
        if (lower.includes('udyam') && (lower.includes('certificate') || lower.includes('registration'))) {
          return 'COM_UDYAM_Certificate.pdf';
        }
        if (lower.includes('bank') && (lower.includes('summary') || lower.includes('statement'))) {
          return 'COM_BANK_Summary.xlsx';
        }
        
        // Balance Sheets
        if ((lower.includes('balance') || lower.includes('bs')) && (lower.includes('2022') || lower.includes('2021-22'))) {
          return '2022_BS.pdf';
        }
        if ((lower.includes('balance') || lower.includes('bs')) && (lower.includes('2023') || lower.includes('2022-23'))) {
          return '2023_BS.pdf';
        }
        if ((lower.includes('balance') || lower.includes('bs')) && (lower.includes('2024') || lower.includes('2023-24'))) {
          return '2024_BS.pdf';
        }
        
        // Profit & Loss
        if ((lower.includes('profit') || lower.includes('pl')) && (lower.includes('2022') || lower.includes('2021-22'))) {
          return '2022_PL.pdf';
        }
        if ((lower.includes('profit') || lower.includes('pl')) && (lower.includes('2023') || lower.includes('2022-23'))) {
          return '2023_PL.pdf';
        }
        if ((lower.includes('profit') || lower.includes('pl')) && (lower.includes('2024') || lower.includes('2023-24'))) {
          return '2024_PL.pdf';
        }
        
        // If no pattern matches, return original filename
        return originalFileName;
      };
      
      // Required files for Super Admin validation
      const REQUIRED_FILES = [
        'COM_LOAN_Application.pdf',
        'PR_AADHAR.pdf',
        'PR_PAN.pdf',
        'PR_2022_ITR.pdf',
        'PR_2023_ITR.pdf',
        'PR_NETWORTH.pdf',
        'PR_CIBIL.pdf',
        'CO1_AADHAR.pdf',
        'CO1_PAN.pdf',
        'CO1_2022_ITR.pdf',
        'CO1_2023_ITR.pdf',
        'CO1_CIBIL.pdf',
        '2022_BS.pdf',
        '2023_BS.pdf',
        '2024_BS.pdf',
        'COM_CIBIL.pdf',
        'COM_GST_Certificate.pdf',
        '2022_PL.pdf',
        '2023_PL.pdf',
        '2024_PL.pdf',
        'COM_UDYAM_Certificate.pdf',
        'COM_BANK_Summary.xlsx'
      ];

      // Extract files from uploaded ZIP files to validate
      let allFilesInZips = [];
      
      try {
        // Use JSZip to extract file names from uploaded ZIP files
        const JSZip = (await import('jszip')).default;
        
        for (const uploadedFile of uploadedFiles) {
          if (uploadedFile.name.toLowerCase().endsWith('.zip')) {
            const zip = new JSZip();
            const zipContent = await zip.loadAsync(uploadedFile.file);
            const filesInZip = Object.keys(zipContent.files).filter(fileName => 
              !zipContent.files[fileName].dir && // Exclude directories
              fileName.split('/').pop() !== '' // Exclude empty names
            ).map(fileName => normalizeFileName(fileName.split('/').pop())); // Normalize filenames
            
            allFilesInZips.push(...filesInZip);
          }
        }
        
        console.log(' Super Admin - Files found in ZIP(s):', allFilesInZips);
        console.log(' Super Admin - Required files count:', REQUIRED_FILES.length);
        
        // Check for missing files
        const missingFiles = REQUIRED_FILES.filter(requiredFile => 
          !allFilesInZips.some(uploadedFile => 
            uploadedFile.toLowerCase() === requiredFile.toLowerCase()
          )
        );
        
        // Check for extra/incorrect files
        const incorrectFiles = allFilesInZips.filter(uploadedFile =>
          !REQUIRED_FILES.some(requiredFile =>
            requiredFile.toLowerCase() === uploadedFile.toLowerCase()
          )
        );
        
        if (missingFiles.length > 0 || incorrectFiles.length > 0) {
          console.error(' Super Admin validation failed');
          console.error(' Missing files:', missingFiles);
          console.error(' Incorrect files:', incorrectFiles);
          
          // Create validation errors in the same format as backend
          const validationErrors = [];
          
          if (missingFiles.length > 0) {
            validationErrors.push({
              type: 'missing_files',
              missingFiles: missingFiles,
              totalRequired: REQUIRED_FILES.length,
              totalUploaded: allFilesInZips.length,
              uploadedFiles: allFilesInZips
            });
          }
          
          if (incorrectFiles.length > 0) {
            validationErrors.push({
              type: 'incorrect_names',
              incorrectFiles: incorrectFiles,
              uploadedFiles: allFilesInZips
            });
          }
          
          if (allFilesInZips.length !== REQUIRED_FILES.length) {
            validationErrors.push({
              type: 'count_mismatch',
              expected: REQUIRED_FILES.length,
              received: allFilesInZips.length,
              uploadedFiles: allFilesInZips
            });
          }
          
          // Show validation dialog
          setValidationErrors(validationErrors);
          setShowValidationDialog(true);
          return; // Stop upload process
        }
        
        console.log(' Super Admin validation passed - All required files present');
        
      } catch (zipError) {
        console.error(' Error reading ZIP files for validation:', zipError);
        // Create a ZIP error validation
        setValidationErrors([{
          type: 'zip_error',
          message: 'Unable to read ZIP file contents for validation. Please ensure you uploaded valid ZIP files.',
          uploadedFiles: []
        }]);
        setShowValidationDialog(true);
        return;
      }
    } else {
      console.log(' Tenant Admin - No additional validation required');
    }

    // Generate folder name based on timestamp or ask user
    const timestamp = new Date().getTime();
    const generatedFolderName = `application_${timestamp}`;
    setFolderName(generatedFolderName);

    setIsUploading(true);

    try {
      // Upload files one by one with progress tracking
      for (let i = 0; i < uploadedFiles.length; i++) {
        setCurrentUploadIndex(i);

        // Update file status to uploading
        setUploadedFiles(prev => prev.map((f, idx) =>
          idx === i ? { ...f, status: 'uploading' } : f
        ));

        // Simulate progress for individual file
        const progressInterval = setInterval(() => {
          setUploadProgress(prev => ({
            ...prev,
            [uploadedFiles[i].id]: Math.min((prev[uploadedFiles[i].id] || 0) + 10, 90)
          }));
        }, 200);

        // Prepare FormData for this file
        const formData = new FormData();
        formData.append('files', uploadedFiles[i].file);
        formData.append('folderName', generatedFolderName);
        if (selectedRowId) {
          formData.append('applicationId', selectedRowId);
        }

        // Upload to backend
        const response = await uploadFolderApi(formData);

        clearInterval(progressInterval);

        // Check for validation errors
        if (!response.success && response.validationErrors) {
          console.log(' Validation failed:', response.validationErrors);
          // Add uploadedFiles to the first error object so it's accessible in the dialog
          const errorsWithFiles = response.validationErrors.map((err, idx) => 
            idx === 0 ? { ...err, uploadedFiles: response.uploadedFiles || [] } : err
          );
          setValidationErrors(errorsWithFiles);
          setShowValidationDialog(true);
          setIsUploading(false);
          setCurrentUploadIndex(-1);
          return; // Stop upload process
        }

        //  Fetch application info from Azure Blob immediately
        if (response.applicationData) {
          const applicationId = response.applicationData.applicationId;
          console.log(' Upload successful, fetching blob info for:', applicationId);
          
          try {
            // Call new API to get application-info.json from Azure Blob
            const blobInfoResponse = await getApplicationBlobInfo(applicationId);
            
            if (blobInfoResponse.success && blobInfoResponse.data) {
              console.log(' [UPLOAD] Blob info fetched successfully:', blobInfoResponse.data);
              console.log(' [UPLOAD] Creation date:', blobInfoResponse.data.createdDate);
              console.log(' [UPLOAD] Status:', blobInfoResponse.data.status);
              
              // Add to UI immediately with data from Azure Blob
              setApplications(prev => [blobInfoResponse.data, ...prev]);
              setPage(1);
            }
          } catch (blobError) {
            console.warn(' Failed to fetch blob info, using response data:', blobError);
            
            // Fallback: Use response data if blob fetch fails
            const fallbackApplication = {
              id: applicationId,
              applicationNo: applicationId,
              borrowerName: '-',
              createdDate: new Date(response.applicationData.uploadDate).toISOString().split('T')[0],
              status: 'Processing',
              documents: response.applicationData.totalFiles || 0,
              typeofLoan: '-',
              facilityamount: '-',
              verification: `0/${response.applicationData.totalFiles || 0}`,
              expandableData: {
                verification: `0/${response.applicationData.totalFiles || 0}`,
                scores: {
                  application: 'N/A',
                  financial: 'N/A',
                  bureau: 'N/A',
                  overall: 'N/A',
                }
              },
              creditMemoProgress: 100
            };
            
            setApplications(prev => [fallbackApplication, ...prev]);
            setPage(1);
          }
        }

        // response is already validated in client; if error it would throw above

        // Set progress to 100%
        setUploadProgress(prev => ({
          ...prev,
          [uploadedFiles[i].id]: 100
        }));

        // Update file status to completed
        setUploadedFiles(prev => prev.map((f, idx) =>
          idx === i ? { ...f, status: 'completed' } : f
        ));

        // Small delay before next file
        await new Promise(resolve => setTimeout(resolve, 500));
      }

      // All files uploaded, show completion UI
      setShowCompletionUI(true);
      setIsUploading(false);

      // Simulate analysis progress
      let progress = 0;
      const completionInterval = setInterval(() => {
        progress += 2;
        setCompletionProgress(progress);

        if (progress >= 100) {
          clearInterval(completionInterval);
          setShowCompletionUI(false);
          setShowSuccessUI(true);
          setPage(1);
          
          //  Wait for Azure Blob to sync, then refresh
          setTimeout(() => {
            console.log('  Triggering dashboard refresh after upload...');
            setRefreshKey((k) => {
              console.log(`  RefreshKey changed from ${k} to ${k + 1}`);
              return k + 1;
            });
            console.log('  Dashboard refresh triggered!');
          }, 5000); // Increased to 5 seconds
        }
      }, 100);

    } catch (error) {
      console.error('Upload error:', error);
      alert(`Upload failed: ${error.message}`);
      setIsUploading(false);
      setCurrentUploadIndex(-1);
    }
  };

  // Sequential upload simulation
  const simulateUpload = async (fileId, index) => {
    return new Promise((resolve) => {
      let progress = 0;
      const interval = setInterval(() => {
        progress += Math.random() * 15 + 5; // Random progress increment

        if (progress >= 100) {
          progress = 100;
          setUploadProgress(prev => ({ ...prev, [fileId]: progress }));

          // Mark file as completed
          setUploadedFiles(prev =>
            prev.map(file =>
              file.id === fileId
                ? { ...file, status: 'completed' }
                : file
            )
          );

          clearInterval(interval);
          resolve();
        } else {
          setUploadProgress(prev => ({ ...prev, [fileId]: progress }));
        }
      }, 100 + Math.random() * 200); // Random interval for realistic feel
    });
  };

  const [openStatusDropdown, setOpenStatusDropdown] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);

  // Add this one
  const [openLoanTypeDropdown, setOpenLoanTypeDropdown] = useState(false);
  // Simulate completion progress
  const simulateCompletionProgress = () => {
    return new Promise((resolve) => {
      let progress = 0;
      const interval = setInterval(() => {
        progress += Math.random() * 10 + 3; // Random progress increment

        if (progress >= 100) {
          progress = 100;
          setCompletionProgress(progress);
          clearInterval(interval);
          setTimeout(() => {
            setShowCompletionUI(false);
            setShowSuccessUI(true);
          }, 1000); // Show completion for 1 second, then show success
          resolve();
        } else {
          setCompletionProgress(progress);
        }
      }, 150 + Math.random() * 200); // Random interval
    });
  };

  const commonFieldStyles = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "2rem",
      height: { xs: "1.875rem", sm: "2.125rem" },
      "& fieldset": { borderColor: "#034A7F" },
      "&:hover fieldset": { borderColor: "#034A7F" },
      "&.Mui-focused fieldset": { borderColor: "#034A7F" },
    },
    // Base input padding
    "& .MuiInputBase-input": { 
      color: "#034A7F", 
      padding: { xs: "0.375rem 0.3125rem", sm: "0.53125rem 0.4375rem" }, 
      fontSize: { xs: "0.75rem", sm: "0.875rem" }
    },
    // Ensure room for end adornment (e.g., chevron) so it doesn't look cut
    "& .MuiInputBase-root.MuiInputBase-adornedEnd .MuiInputBase-input": {
      paddingLeft: { xs: "0.03125rem", sm: "0.0625rem" },
    },
    "& .MuiInputLabel-root": { 
      color: "#034A7F", 
      fontSize: { xs: "0.75rem", sm: "0.875rem" }
    },
    "& .MuiInputLabel-root.Mui-focused": { color: "#034A7F" },
  };

  const statusImages = {
    Approved: approve,
    "In Progress": inprogress,
  };

const gridColumnTemplate = {
  xs: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(2.5rem, 2.5rem)',
  sm: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(2.5rem, 2.5rem)',
  md: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(2.5rem, 2.5rem)',
  lg: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(2.5rem, 2.5rem)',
};

  return (
   <Box sx={{  width: "100%", px: { xs: "0.5rem", sm: "0.75rem" }, py: { xs: '0.25rem', sm: '0.5rem' }, minHeight: '100vh', position: 'relative' }}>
    
    
    <StatsCards onFilterChange={handleStatsFilterChange} />


      {/* Data Table */}
      <Paper
        sx={{
          width: "100%",
          mb: { xs: "0.5rem", sm: "1rem" },
          flex: 1,
          mt: { xs: "0.75rem", sm: "1.5rem" },
          display: 'flex',
          flexDirection: 'column',
          boxShadow: 'none',
          border: 'none',
          backgroundColor: 'transparent',
          minHeight: { xs: 'calc(100vh - 8rem)', sm: 'calc(100vh - 10rem)', md: 'calc(100vh - 12.5rem)' },
        }}
      >

        <Box sx={{ display: 'flex', flexDirection: 'column', flex: "1 1 auto", bgcolor: '#fff' }}>
          <TableContainer
            ref={tableContainerRef}
            sx={{
              width: '100%',
              mx: 'auto',
              boxSizing: 'border-box',
              flex: "1 1 auto",
              overflowY: "auto",
              scrollbarWidth: "none",
              overflowX: { xs: "auto", md: "hidden" },
              minHeight: { xs: "20rem", md: "25rem" },
              maxHeight: { xs: "calc(100vh - 15rem)", md: "calc(100vh - 20rem)" },
              scrollbarGutter: "stable both-edges",
              "&::-webkit-scrollbar": { width: "0.5rem", height: "0.5rem" },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f5f5f5",
                borderRadius: "0.25rem",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#c1c1c1",
                borderRadius: "0.25rem",
                "&:hover": { backgroundColor: "#a8a8a8" },
              },
            }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                borderCollapse: 'separate',
                borderSpacing: { xs: '0 0.125rem', sm: '0 0.25rem' },
                width: 'auto',
                minWidth: { xs: '56.25rem', md: '100%' },
                fontFamily: '"Nunito Sans","Roboto","Arial",sans-serif',
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell colSpan={5} sx={{ p: 0, border: "none" }}>
                 {/*Tableheader box */}
                    <Box
                      sx={{
                          display: "grid",
                          alignItems: "center",
                          width: "100%",
                          gridTemplateColumns: gridColumnTemplate, //  Use shared template
                          px: { xs: "0.5rem", sm: "0.75rem" },
                          py: { xs: "0.5rem", sm: "0.75rem" },
                          backgroundColor: "#C7C7C7",
                          gap: { xs: "0.5rem", sm: "1rem" },
                          borderRadius: "0.75rem",
                          boxShadow: "0 0.0625rem 0.1875rem rgba(0,0,0,0.05)",
                      }}
                    >
 
                      {/* Application No Search */}
                      <Box sx={{ position: "relative" }}>
                        <TextField
                          placeholder="Application No"
                          size="small"
                          value={filters.applicationNo}
                          onChange={(e) => {
                            const value = e.target.value;
                            handleFilterChange("applicationNo", value);
                            // Show dropdown only if 3+ characters typed
                            if (value.length >= 3) {
                              setOpenApplicationNoDropdown(true);
                            } else {
                              setOpenApplicationNoDropdown(false);
                            }
                          }}
                          inputRef={applicationNoRef}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <ArrowDropDown sx={{ color: "#7A7A7A", fontSize: "1.375rem" }} />
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            ...commonFieldStyles,
                            backgroundColor: "transparent",
                            borderRadius: 0,
                            width: '100%',
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 0,
                              "& fieldset": { border: "none" },
                              "&:hover fieldset": { border: "none" },
                              "&.Mui-focused fieldset": { border: "none" },
                            },
                            "& .MuiInputBase-input": {
                              fontWeight: 700,
                              color: "#034A7F",
                              "&::placeholder": {
                                color: "#034A7F",
                                opacity: 1,
                                fontWeight: 700,
                              },
                            },
                          }}
                        />
 
                        {openApplicationNoDropdown &&
                          filters.applicationNo.length >= 3 &&
                          applicationNoOptions.length > 0 && (
                            <Paper
                              sx={{
                                position: "absolute",
                                top: "2.8rem",
                                left: 0,
                                right: 0,
                                zIndex: 10,
                                maxHeight: "12.5rem",
                                overflowY: "auto",
                                borderRadius: "0.75rem",
                              }}
                            >
                              <List dense>
                                {applicationNoOptions.map((option) => (
                                  <ListItemButton
                                    key={option}
                                    onClick={() => handleSelectOption("applicationNo", option)}
                                  >
                                    <ListItemText primary={option} />
                                  </ListItemButton>
                                ))}
                              </List>
                            </Paper>
                          )}
                      </Box>
 
                      {/* Created Date - MUI Pro DateRangePicker */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DateRangePicker
    value={value}
    onChange={(newRange) => {
      console.log('[DATE PICKER] Date range changed:', newRange);
      setValue(newRange);
      const [start, end] = newRange || [];
      const startDateStr = start ? dayjs(start).format('YYYY-MM-DD') : '';
      const endDateStr = end ? dayjs(end).format('YYYY-MM-DD') : '';
      
      console.log('[DATE PICKER] Formatted dates:', { startDateStr, endDateStr });
      
      setFilters((prev) => ({
        ...prev,
        startDate: startDateStr,
        endDate: endDateStr,
      }));
      setPage(1);
    }}
    calendars={2}
    localeText={{
      start: 'Select Date',
      end: 'Select Date',
    }}
    slotProps={{
      textField: {
        placeholder: 'Select Date',
        size: 'small',
        sx: {
          ...commonFieldStyles,
          width: "100%",
          borderRadius: 0,
          backgroundColor: 'transparent',
          '& .MuiOutlinedInput-root': {
            borderRadius: 0,
            paddingRight: { xs: '0.125rem', sm: '0.25rem' },
            '& fieldset': { border: 'none' },
            '&:hover fieldset': { border: 'none' },
            '&.Mui-focused fieldset': { border: 'none' },
          },
          '& .MuiInputBase-input::placeholder': {
            fontWeight: 700,
            color: '#034A7F',
            fontSize: '0.875rem',
            opacity: 1,
          },
        },
      },
      field: {
        clearable: true,
        onClear: () => {
          setValue([null, null]);
          setFilters((prev) => ({
            ...prev,
            startDate: '',
            endDate: '',
          }));
          setPage(1);
        },
      },
    }}
  />
</LocalizationProvider>
                     
 
                      {/* Borrower Name Search */}
                      <Box sx={{ position: "relative" }}>
                        <TextField
                          placeholder="Borrower Name"
                          size="small"
                          value={filters.borrowerName}
                          onChange={(e) => {
                            const value = e.target.value;
                            handleFilterChange("borrowerName", value);
                            // Show dropdown only if 3+ characters typed
                            if (value.length >= 3) {
                              setOpenBorrowerNameDropdown(true);
                            } else {
                              setOpenBorrowerNameDropdown(false);
                            }
                          }}
                          inputRef={borrowerNameRef}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <ArrowDropDown sx={{ color: "#7A7A7A", fontSize: "1.375rem" }} />
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            ...commonFieldStyles,
                            backgroundColor: "transparent",
                            borderRadius: 0,
                             width: '100%',
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 0,
                              "& fieldset": { border: "none" },
                              "&:hover fieldset": { border: "none" },
                              "&.Mui-focused fieldset": { border: "none" },
                            },
                            "& .MuiInputBase-input": {
                              fontWeight: 700,
                              color: "#034A7F",
                              fontSize: "0.875rem",
                              "&::placeholder": {
                                color: "#034A7F",
                                opacity: 1,
                                fontWeight: 700,
                                fontSize: "0.875rem",
                              },
                            },
                          }}
                        />
 
                        {openBorrowerNameDropdown &&
                          filters.borrowerName.length >= 3 &&
                          borrowerNameOptions.length > 0 && (
                            <Paper
                              sx={{
                                position: "absolute",
                                top: "2.8rem",
                                left: 0,
                                right: 0,
                                zIndex: 10,
                                maxHeight: "12.5rem",
                                overflowY: "auto",
                                borderRadius: "0.75rem",
                              }}
                            >
                              <List dense>
                                {borrowerNameOptions.map((option) => (
                                  <ListItemButton
                                    key={option}
                                    onClick={() => handleSelectOption("borrowerName", option)}
                                  >
                                    <ListItemText primary={option} />
                                  </ListItemButton>
                                ))}
                              </List>
                            </Paper>
                          )}
                      </Box>
 
                      {/* Type of Loan selector 16/12 */}
                      {/* <Box sx={{ position: "relative" }}>
                        <TextField
                          placeholder="Type of Loan"
                          size="small"
                          value={filters.loanType}
                          onChange={(e) => {
                            const value = e.target.value;
                            handleFilterChange("loanType", value);
                            // Show dropdown only if 3+ characters typed
                            if (value.length >= 3) {
                              setOpenLoanTypeDropdown(true);
                            } else {
                              setOpenLoanTypeDropdown(false);
                            }
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <ArrowDropDown sx={{ color: "#7A7A7A", fontSize: "1.375rem" }} />
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            ...commonFieldStyles,
                            backgroundColor: "transparent",
                            borderRadius: 0,
                             width: '100%',
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 0,
                              "& fieldset": { border: "none" },
                              "&:hover fieldset": { border: "none" },
                              "&.Mui-focused fieldset": { border: "none" },
                            },
                            "& .MuiInputBase-input": {
                              fontWeight: 700,
                              color: "#034A7F",
                              "&::placeholder": {
                                color: "#034A7F",
                                opacity: 1,
                                fontWeight: 700,
                              },
                            },
                          }}
                        />
 
                        {openLoanTypeDropdown &&
                          filters.loanType.length >= 3 &&
                          loanTypeOptions?.length > 0 && (
                            <Paper
                              sx={{
                                position: "absolute",
                                top: "2.8rem",
                                left: 0,
                                right: 0,
                                zIndex: 10,
                                maxHeight: "12.5rem",
                                overflowY: "auto",
                                borderRadius: "0.75rem",
                              }}
                            >
                              <List dense>
                                {loanTypeOptions.map((option) => (
                                  <ListItemButton
                                    key={option}
                                    onClick={() => {
                                      handleSelectOption("loanType", option);
                                      // setOpenLoanTypeDropdown(false); 15/12 //
                                    }}
                                  >
                                    <ListItemText primary={option} />
                                  </ListItemButton>
                                ))}
                              </List>
                            </Paper>
                          )}
                      </Box> */}
                      
                      {/* Type of Loan selector - Styled like Borrower Name */}
                      <Box sx={{ position: "relative" }}>
                       
                       
                        <FormControl 
                          size="small" 
                          sx={{ 
                            width: '100%',
                            // Remove default FormControl styling
                            '& .MuiOutlinedInput-root': {
                              borderRadius: 0,
                              '& fieldset': { border: 'none' },
                              '&:hover fieldset': { border: 'none' },
                              '&.Mui-focused fieldset': { border: 'none' },
                            }
                          }}
                        >
                          <Select
                            value={filters.loanType}
                            onChange={(e) => handleFilterChange('loanType', e.target.value)}
                            displayEmpty
                             renderValue={(selected) => {
                              if (!selected) {
                                // Custom placeholder with exact same styling as TextField
                                return (
                                  <span style={{ 
                                    color: "#034A7F", 
                                    fontWeight: 700,
                                    fontSize: "0.875rem",
                                    opacity: 1
                                  }}>
                                    Type of Loan
                                  </span>
                                );
                              }
                              return selected;
                            }}
                            IconComponent={(props) => (
                              <ArrowDropDown {...props} sx={{ color: "#7A7A7A", fontSize: "1.375rem" }} />
                            )}
                            sx={{
                              backgroundColor: "transparent",
                              borderRadius: 0,
                              width: '100%',
                              // Match TextField input styling
                              '& .MuiSelect-select': {
                                fontWeight: 700,
                                color: "#034A7F",
                                padding: { xs: "0.375rem 0.3125rem", sm: "0.53125rem 0.4375rem" },
                                fontSize: "0.875rem",
                              },
                              // Placeholder styling
                              '& .MuiSelect-select[aria-expanded="false"]:not([value])': {
                                color: "#034A7F",
                                opacity: 1,
                              },
                              // Remove all borders
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                              },
                              '&:hover .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                              },
                              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                              },
                            }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  borderRadius: "0.75rem",
                                  maxHeight: "12.5rem",
                                  '& .MuiMenuItem-root': {
                                    fontSize: "0.875rem",
                                    '&:hover': {
                                      backgroundColor: 'rgba(3, 74, 127, 0.08)',
                                    },
                                    '&.Mui-selected': {
                                      backgroundColor: 'rgba(3, 74, 127, 0.12)',
                                      '&:hover': {
                                        backgroundColor: 'rgba(3, 74, 127, 0.16)',
                                      },
                                    },
                                  },
                                },
                              },
                            }}
                          >
                            <MenuItem value="">
                              <em style={{ fontStyle: 'normal', color: '#666' }}>All</em>
                            </MenuItem>
                            {loanTypeOptions.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
 
                      {/* Facility Amount filter */}
                      <Box>
                        <TextField
                          placeholder="Loan Amount"
                          size="small"
                          value={filters.facilityAmount}
                          onChange={(e) => handleFilterChange('facilityAmount', e.target.value)}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <ArrowDropDown sx={{ color: '#7A7A7A', fontSize: "1.375rem" }} />
                              </InputAdornment>
                            )
                          }}
                          sx={{
                            ...commonFieldStyles,
                            backgroundColor: 'transparent',
                            borderRadius: 0,
                              width: '100%',
                            '& .MuiOutlinedInput-root': {
                              borderRadius: 0,
                              '& fieldset': { border: 'none' },
                              '&:hover fieldset': { border: 'none' },
                              '&.Mui-focused fieldset': { border: 'none' },
                            },
                            "& .MuiInputBase-input": {
                              fontWeight: 700,
                              color: "#034A7F",
                              fontSize: "0.875rem",
                              "&::placeholder": {
                                color: "#034A7F",
                                opacity: 1,
                                fontWeight: 700,
                                 fontSize: "0.875rem",
                              },
                            },
                          }}
                        />
                      </Box>
 
                      {/* Status Select  11/12  15/12*/}



                  

                    <FormControl
                        size="small"
                        sx={{
                          width: "100%",
                          backgroundColor: "transparent",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": { border: "none" },
                          },
                        }}
                      >
                        
                        <Select
                          multiple
                          value={Array.isArray(filters.status) && filters.status.length > 0
                            ? filters.status
                            : ["Approved", "Onboarding", "Rejected", "Processing"]} // Default to all selected including Processing
                          onChange={(e) => {
                            const value = e.target.value;
                           
                            // Handle "Select All"
                            if (value.includes("SELECT_ALL")) {
                              const allStatuses = ["Approved", "Onboarding", "Rejected"];
                              const currentFiltered = Array.isArray(filters.status) && filters.status.length > 0
                                ? filters.status
                                : allStatuses;
                             
                              // If all are selected, deselect all. Otherwise, select all
                              if (currentFiltered.length === allStatuses.length) {
                                handleFilterChange("status", []);
                              } else {
                                handleFilterChange("status", allStatuses);
                              }
                              return;
                            }
                           
                            // Handle "Clear"
                            if (value.includes("CLEAR")) {
                              handleFilterChange("status", []);
                              return;
                            }
                           
                            // Normal selection - toggle individual items
                            handleFilterChange("status", value);
                          }}
                          displayEmpty
                          renderValue={() => (
                            <span style={{ color: "#034A7F", fontWeight: 700 }}>Status</span>
                          )}
                          sx={{
                            "& .MuiSelect-select": {
                              fontWeight: 700,
                              color: "#034A7F",
                              padding: { xs: "0.375rem 1.5rem 0.375rem 0.375rem", sm: "0.5rem 2rem 0.5rem 0.5rem" },
                            },
                          }}
                          IconComponent={(props) => (
                            <ArrowDropDown {...props} sx={{ color: "#7A7A7A", fontSize: "1.375rem" }} />
                          )}
                        >
                          {/* Select All Option */}
                          <MenuItem value="SELECT_ALL">
                            <Checkbox
                              checked={
                                (Array.isArray(filters.status) && filters.status.length === 3) ||
                                (!Array.isArray(filters.status) || filters.status.length === 0)
                              }
                              indeterminate={
                                Array.isArray(filters.status) &&
                                filters.status.length > 0 &&
                                filters.status.length < 3
                              }
                              sx={{ color: "#034A7F" }}
                            />
                            <ListItemText primary="Select All" sx={{ fontWeight: 700 }} />
                          </MenuItem>
 
                          <Divider />
 
                          {/* Individual Status Options */}
                          {["Approved", "Onboarding", "Rejected"].map((item) => {
                            const currentStatus = Array.isArray(filters.status) && filters.status.length > 0
                              ? filters.status
                              : ["Approved", "Onboarding", "Rejected"];
                           
                            return (
                              <MenuItem key={item} value={item}>
                                <Checkbox
                                  checked={currentStatus.includes(item)}
                                  sx={{ color: "#034A7F" }}
                                />
                                <ListItemText primary={item} />
                              </MenuItem>
                            );
                          })}
 
                          <Divider />
 
                          {/* Clear Option — show ONLY when 1 or 2 items are selected */}
                          {Array.isArray(filters.status) &&
                          filters.status.length > 0 &&
                          filters.status.length < 3 && (
                            <MenuItem
                              value="CLEAR"
                              sx={{
                                justifyContent: "center",
                                color: "#034A7F",
                                fontWeight: 700,
                              }}
                            >
                              Clear Filter
                            </MenuItem>
                          )}
                        </Select>
                      </FormControl>
 

      
                      {/* Placeholder to align with expand icon column */}
                      <Box
                                sx={{
                                  minWidth: { xs: "1.875rem", sm: "2.125rem" },
                                  height: "100%",
                                }}
                      />
 
                   </Box>
 
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {loading && (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      <CircularProgress size={20} />
                    </TableCell>
                  </TableRow>
                )}
                {!loading && error && (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      <Typography color="error">{error}</Typography>
                    </TableCell>
                  </TableRow>
                )}
                {!loading && !error && filteredData.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      <Typography>No records found</Typography>
                    </TableCell>
                  </TableRow>
                )}
                {!loading && !error && filteredData.map((row, index) => {
                  const isSelected = selectedRowId === row.id;
                  const isExpanded = expandedRow === row.id;

                  return (
                    <React.Fragment key={row.id}>
                      {/* Main Row */}
                      <TableRow
                        onClick={() => setSelectedRowId(row.id)}
                        sx={{ 
                          '& td': { border: 'none', p: 0 },
                          ...(index === 0 && { '& td': { border: 'none', p: 0, paddingTop: '0.75rem' } })
                        }}
                      >
                        <TableCell colSpan={5} sx={{ p: 0 }}>
                        {/*Tablerow  box */}
                          <Box
                            onDoubleClick={() => {
                              navigate(`/applicationsummary?id=${encodeURIComponent(row.id)}`);
                            }}
                            sx={{
                             display: "grid",
                            alignItems: "center",
                            width: "100%",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            backgroundColor: (isSelected || isExpanded) ? '#034A75' : '#fff',
                            borderRadius: isExpanded ? '0.75rem 0.75rem 0 0' : '0.75rem',
                            borderLeft: '0.125rem solid rgba(0,0,0,0.04)',
                            borderRight: '0.125rem solid rgba(0,0,0,0.04)',
                            boxShadow: isExpanded
                              ? 'none'
                              : isSelected
                                ? 'none'                // selected pe koi shadow nahi
                                : '0 0 0.5rem rgba(0,0,0,0.08)',
 
                            cursor: 'pointer',
                            // display: 'grid',
                            gridTemplateColumns: gridColumnTemplate, //  Use shared template
                            gap: 0,
                            // gap: "1rem", //  Add same gap as header
                            // gridTemplateColumns: { xs: '1.4fr 1fr 1fr 1fr 1fr 1.2fr auto', sm: '1.2fr 1fr 1fr 1fr 1fr 1.2fr auto', md: '1fr 1fr 1fr 1fr 1fr 1fr auto', lg: '1fr 1fr 1fr 1fr 1fr 1fr auto' },
                            // alignItems: "center",
                            px: { xs: "0.5rem", sm: "0.75rem" },
                            py: { xs: "0.4rem", sm: "0.5rem" },
                            //     '& .MuiSvgIcon-root': { color: '#fff' },
                            // },
                            color: (isSelected || isExpanded) ? '#fff' : '#222',
                            transition: 'all 0.2s ease-in-out',
                          }}>
 
                            {/* <Typography
                              sx={{ color: (isSelected || isExpanded) ? '#fff' : '#034A7F', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.875rem' }}
                              align="left"
                            >
                              {row.id}
                            </Typography>
 
                          <Typography align="left" sx={{ color: (isSelected || isExpanded) ? '#fff' : '#034A7F', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.875rem', ml: '5%' }}>{row.createdDate}</Typography>
                            <Typography align="left" sx={{ color: (isSelected || isExpanded) ? '#fff' : '#034A7F', fontWeight: 500, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.875rem' , ml: '5%'}} >{row.borrowerName}</Typography>
                            <Typography align="left" sx={{ color: (isSelected || isExpanded) ? '#fff' : '#034A7F', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.875rem', ml: '10%' }}>{row.typeofLoan}</Typography>
                            <Typography align="center" sx={{ color: (isSelected || isExpanded) ? '#fff' : '#034A7F', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', ml: '-8%' }}>{formatToIndianCurrency(row.facilityamount)}</Typography> */}
 
                             <Typography
                              sx={{ color: (isSelected || isExpanded) ? '#fff' : '#034A7F', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                              align="left"
                            >
                              {row.id}
                            </Typography>
 
                          <Typography align="left" sx={{ color: (isSelected || isExpanded) ? '#fff' : '#034A7F', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>{row.createdDate}</Typography>
                            <Typography align="left" sx={{ color: (isSelected || isExpanded) ? '#fff' : '#034A7F', fontWeight: 500, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',fontSize: { xs: '0.75rem', sm: '0.875rem' }}} >{row.borrowerName}</Typography>
                            <Typography align="left" sx={{ color: (isSelected || isExpanded) ? '#fff' : '#034A7F', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>{row.typeofLoan}</Typography>
                            <Typography align="left" sx={{ color: (isSelected || isExpanded) ? '#fff' : '#034A7F', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>{formatToIndianCurrency(row.facilityamount)}</Typography>
 
 
                       
                            {/* Status Column */}
 
                              <Typography
                              align="left"
                                sx={{
                                  color: (isSelected || isExpanded) ? '#fff' : '#034A7F',
                                  fontWeight: 400,
                                  textTransform: 'capitalize',
                                  // textAlign: 'left',
                                  // pl: '8px',
                                  minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                                 
                                }}
                              >
                                {(() => {
                                  if (!row.status) return "";
                                 
                                  // Normalize row status for display
                                  const status = row.status.toLowerCase().replace(/\s+/g, '');
                                  switch (status) {
                                    case 'approved':
                                      return 'Approved';
                                    case 'onboarding':
                                      return 'On Boarding';
                                    case 'rejected':
                                      return 'Rejected';
                                    default:
                                      return row.status;
                                  }
                                })()}
                              </Typography>
                              <Typography>
                               
                                 <Tooltip title={isExpanded ? "Hide details" : "Show details"}>
                                <IconButton
                                  size="small"
                                  sx={{
                                   
                                    color: (isSelected || isExpanded) ? '#fff' : '#034A7F',
                                    justifySelf: "center",
                                    transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s',
                                    cursor: 'pointer',
                                    '&:hover': {
                                      backgroundColor: 'transparent'  // No background on hover
                                    },
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleToggleExpand(row.id);
                                  }}
                                >
                                  <KeyboardArrowDown />
                                </IconButton>
                              </Tooltip>
                              </Typography>
                             
 
 
 
 
                            {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, justifySelf: 'center' }}> */}
                            {/* <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", justifySelf: "end"}} >
 
                              <Tooltip title={isExpanded ? "Hide details" : "Show details"}>
                                <IconButton
                                  size="small"
                                  sx={{
                                    color: (isSelected || isExpanded) ? '#fff' : '#034A7F',
                                    justifySelf: "center",
                                    transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s',
                                    cursor: 'pointer',
                                    '&:hover': {
                                      backgroundColor: 'transparent'  // No background on hover
                                    },
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleToggleExpand(row.id);
                                  }}
                                >
                                  <KeyboardArrowDown />
                                </IconButton>
                              </Tooltip>
                            </Box> */}
                            </Box>
 
 
                        </TableCell>
                      </TableRow>


                      {/* Collapsible Details */}
                      <TableRow>
                        <TableCell colSpan={5} sx={{ p: 0, border: "none" }}>
                          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                              <Box
                              sx={{
                                backgroundColor: "#fff",
                                p: "1rem",
                                borderRadius: "0 0 0.75rem 0.75rem",
                                border: "0.0625rem solid rgba(3, 74, 127, 0.1)",
                                borderTop: "none",
                              }}
                            >
                        <Box
                                sx={{
                                  display: "flex",
                                  // flexDirection: { xs: "column", md: "row" },
                                  alignItems: "stretch",
                                  justifyContent: "space-between",
                                  width: "100%",
                                  gap: "1rem",
                                  //  gap: { xs: "0.75rem", md: "1rem" },
                                }}
                              >
                                {[
                                  {
                                    icon: fileUploadIcon,
                                    title: "Documents",
                                    value: row.expandableData?.filesUploaded || `${row.documents}/22`,
                                  },
                                  {
                                    icon: verificationIcon,
                                    title: `Verification`,
                                    value: row.verification || '0/0',
                                    showDivider: true,
                                  },
                                  {
                                    icon: applicationScoreIcon,
                                    title: "Profile",
                                    value: row?.expandableData?.scores?.application && !isNaN(parseFloat(row.expandableData.scores.application))
                                      ? parseFloat(row.expandableData.scores.application).toFixed(1)
                                      : "N/A",
                                    isScore: true,
                                    rawValue: row?.expandableData?.scores?.application,
                                  },
                                  {
                                    icon: financialScoreIcon,
                                    title: "Financial",
                                    value: row?.expandableData?.scores?.financial && !isNaN(parseFloat(row.expandableData.scores.financial))
                                      ? parseFloat(row.expandableData.scores.financial).toFixed(1)
                                      : "N/A",
                                    isScore: true,
                                    rawValue: row?.expandableData?.scores?.financial,
                                  },
                                  {
                                    icon: bureauScoreIcon,
                                    title: "Bureau",
                                    value: row?.expandableData?.scores?.bureau && !isNaN(parseFloat(row.expandableData.scores.bureau))
                                      ? parseFloat(row.expandableData.scores.bureau).toFixed(1)
                                      : "N/A",
                                    isScore: true,
                                    rawValue: row?.expandableData?.scores?.bureau,
                                  },
                                  {
                                    icon: lowRiskIcon,
                                    title: "Overall",
                                    value: row?.expandableData?.scores?.overall && !isNaN(parseFloat(row.expandableData.scores.overall))
                                      ? parseFloat(row.expandableData.scores.overall).toFixed(1)
                                      : "N/A",
                                    isScore: true,
                                    rawValue: row?.expandableData?.scores?.overall,
                                  },
                                ].map((item, index) => {
         
                                const isDocument = item.title === "Documents";
                                const isVerification = item.title === "Verification";
 
                                // --- Verification logic ---
                                let verificationValue = null;
                                if (isVerification && item.value !== "N/A") {
                                  const parts = item.value.split("/");
                                  verificationValue = parts[0] ? parseInt(parts[0], 10) : null;
                                }
                                const highlightVerification =
                                  isVerification && verificationValue !== null && verificationValue < 21;
 
                                // --- Score logic ---
                                const isValidScore =
                                  item.isScore &&
                                  item.rawValue != null &&
                                  !isNaN(parseFloat(item.rawValue));
 
                                const score = isValidScore ? Number(parseFloat(item.rawValue).toFixed(1)) : null;
                                const highlightScore = score !== null && score < 3.5;
 
                                // --- Final highlight ---
                                const shouldHighlight = highlightVerification || highlightScore;
 
                                // --- Colors ---
                                const backgroundColor = shouldHighlight ? "#ff7769" : "#fff";
                                const titleColor = shouldHighlight ? "#fff" : "#034A7F";
                                const valueColor = shouldHighlight ? "#fff" : "#C7C7C7";
 
                                const iconFilter = shouldHighlight ? "brightness(0) invert(1)" : "none";
                                return (
                                  <React.Fragment key={index}>
                                  <Box
                                    sx={{
                                      border: "0.0625rem solid #e0e0e0",
                                      borderRadius: "0.75rem",
                                      boxShadow: "0 0.25rem 0.75rem rgba(0, 0, 0, 0.05)",
                                      p: "1rem",
                                      // p: { xs: "0.75rem", md: "1rem" },
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "0.75rem",
                                      backgroundColor,
                                      flex: 1,
                                      transition: "0.3s ease",
                                    }}
                                  >
                                    {/* <img src={item.icon} style={{ width: 35, height: 35, filter: iconFilter }} />
                                     */}
                                     <Box
                                      component="img"
                                      src={item.icon}
                                      sx={{
                                        width: { xs: 28, sm: 30, md: 35 },
                                        height: { xs: 28, sm: 30, md: 35 },
                                        filter: iconFilter
                                      }}
                                    />
 
                                    <Box>
                                      <Typography sx={{ color: titleColor, fontWeight: 600, fontSize: { xs: "0.65rem", sm: "0.7rem", md: "0.8rem" } }}>
                                        {item.title}
                                      </Typography>
 
                                      <Typography sx={{ color: valueColor, fontWeight: 600, fontSize: { xs: "0.65rem", sm: "0.7rem", md: "0.8rem" } }}>
                                        {item.value}
                                      </Typography>
                                    </Box>
                                  </Box>
 
                                  {item.showDivider && (
                                    <Divider orientation="vertical" flexItem sx={{ mx: "1rem", borderColor: "rgba(0,0,0,0.1)" }} />
                                  )}
                                </React.Fragment>
                                );
 
 
                                })}
                              </Box>
 
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>




                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>      
      {/* Fixed Pagination at Bottom - Outside the Paper component  15/12*/}
      {statsFilterApplied && (
      <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "center", md: "flex-start" },
          alignItems: "center",
          px: { xs: '0.25rem', sm: '0.5rem'},
          py: { xs: '1rem', sm: '2rem' },
          flexWrap: "wrap",
          gap: { xs: '0.25rem', sm: '0.5rem' },
          minHeight: { xs: '2.5rem', sm: '3.75rem' },
          backgroundColor: "#fff",
          position: 'sticky',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 10,
          marginTop: 'auto' // Push to bottom
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* Rows per page info */}
          {/* <Typography variant="body2" sx={{ color: '#666', fontSize: '0.875rem', mr: 1 }}>
            Showing {((page - 1) * rowsPerPage) + 1}-{Math.min(page * rowsPerPage, filteredData.length)} of {filteredData.length} entries
          </Typography>
           */}
          {/* First page button */}
          <IconButton
            size="small"
            onClick={() => handleChangePage(null, 1)}
            disabled={page === 1}
            sx={{
              minWidth: { xs: '1.5rem', sm: '2rem' },
              height: { xs: '1.5rem', sm: '2rem' },
              border: '0.0625rem solid #d0d7de',
              borderRadius: '4rem',
              '&:hover': {
                backgroundColor: '#f8f8f8'
              },
              '&:disabled': {
                opacity: 0.5
              }
            }}
          >
            <Typography variant="caption">{'<<'}</Typography>
          </IconButton>

          {/* Previous page button */}
          <IconButton
            size="small"
            onClick={() => handleChangePage(null, page - 1)}
            disabled={page === 1}
            sx={{
              minWidth: '2rem',
              height: '2rem',
              border: '0.0625rem solid #d0d7de',
              borderRadius: '4rem',
              '&:hover': {
                backgroundColor: '#f6f8fa'
              },
              '&:disabled': {
                opacity: 0.5
              }
            }}
          >
            <Typography variant="caption">{'<'}</Typography>
          </IconButton>

          {/* Page numbers */}
          {Array.from({ length: Math.min(totalPages, 5) }, (_, index) => {
            let pageNumber;
            if (totalPages <= 5) {
              pageNumber = index + 1;
            } else if (page <= 3) {
              pageNumber = index + 1;
            } else if (page >= totalPages - 2) {
              pageNumber = totalPages - 4 + index;
            } else {
              pageNumber = page - 2 + index;
            }

            return (
              <IconButton
                key={pageNumber}
                size="small"
                onClick={() => handleChangePage(null, pageNumber)}
                sx={{
                  minWidth: { xs: '1.5rem', sm: '2rem' },
                  height: { xs: '1.5rem', sm: '2rem' },
                  border: '0.0625rem solid #d0d7de',
                  borderRadius: '4rem',
                  backgroundColor: page === pageNumber ? '#034A7F' : 'transparent',
                  color: page === pageNumber ? 'white' : '#034A7F',
                  '&:hover': {
                    backgroundColor: page === pageNumber ? '#034A7F' : '#f6f8fa'
                  }
                }}
              >
                <Typography variant="caption" sx={{ fontWeight: 500 }}>
                  {pageNumber}
                </Typography>
              </IconButton>
            );
          })}

          {/* Show ellipsis and last page if needed */}
          {totalPages > 5 && page < totalPages - 2 && (
            <>
              <Typography variant="caption" sx={{ px: '0.5rem', color: '#656d76' }}>
                ...
              </Typography>
              <IconButton
                size="small"
                onClick={() => handleChangePage(null, totalPages)}
                sx={{
                  minWidth: { xs: '1.5rem', sm: '2rem' },
                  height: { xs: '1.5rem', sm: '2rem' },
                  border: '0.0625rem solid #d0d7de',
                  borderRadius: '4rem',
                  '&:hover': {
                    backgroundColor: '#f6f8fa'
                  }
                }}
              >
                <Typography variant="caption" sx={{ fontWeight: 500 }}>
                  {totalPages}
                </Typography>
              </IconButton>
            </>
          )}

          {/* Next page button */}
          <IconButton
            size="small"
            onClick={() => handleChangePage(null, page + 1)}
            disabled={page === totalPages}
            sx={{
              minWidth: { xs: '1.5rem', sm: '2rem' },
              height: { xs: '1.5rem', sm: '2rem' },
              border: '0.0625rem solid #d0d7de',
              borderRadius: '4rem',
              '&:hover': {
                backgroundColor: '#f6f8fa'
              },
              '&:disabled': {
                opacity: 0.5
              }
            }}
          >
            <Typography variant="caption">{'>'}</Typography>
          </IconButton>

          {/* Last page button */}
          <IconButton
            size="small"
            onClick={() => handleChangePage(null, totalPages)}
            disabled={page === totalPages}
            sx={{
              minWidth: { xs: '1.5rem', sm: '2rem' },
              height: { xs: '1.5rem', sm: '2rem' },
              border: '0.0625rem solid #d0d7de',
              borderRadius: '4rem',
              '&:hover': {
                backgroundColor: '#f6f8fa'
              },
              '&:disabled': {
                opacity: 0.5
              }
            }}
          >
            <Typography variant="caption">{'>>'}</Typography>
          </IconButton>
        </Box>
      </Box>

        )}

        
{/* Floating + Button - Bottom Right */}
       {/* Floating + Button - Bottom Right */}
      <Fab
        color="primary"
        onClick={handlePlusButtonClick}
        sx={{
          position: 'fixed',
          bottom: { xs: '1rem', sm: '1.25rem', md: '1.875rem' },
          right: { xs: '1rem', sm: '1.25rem', md: '1.875rem' },
          backgroundColor: '#034A7F',
          '&:hover': {
            backgroundColor: '#02365a',
          },
          zIndex: 1000,
          width: { xs: '2.5rem', sm: '3.125rem', md: '3.5rem' },
          height: { xs: '2.5rem', sm: '3.125rem', md: '3.5rem' },
        }}
      >
        <Add />
      </Fab>
 
       {/* Credit Memo Progress Modal - Unique Design */}
      <Dialog
        open={showProgressModal}
        onClose={() => setShowProgressModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '1rem',
            boxShadow: "0 1.25rem 3.75rem rgba(3, 74, 127, 0.15)",
            border: "0.0625rem solid rgba(3, 74, 127, 0.1)",
            overflow: 'hidden',
            position: 'relative'
          }
        }}
      >
        {/* Gradient Header */}
        <Box sx={{
          background: 'linear-gradient(135deg, #034A7F 0%, #1976d2 100%)',
          p: '1.5rem',
          color: 'white',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <Box sx={{
            position: 'absolute',
            top: '-3.125rem',
            right: '-3.125rem',
            width: '6.25rem',
            height: '6.25rem',
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.1)',
            zIndex: 0
          }} />
          <Box sx={{
            position: 'absolute',
            bottom: '-1.875rem',
            left: '-1.875rem',
            width: '5rem',
            height: '5rem',
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.08)',
            zIndex: 0
          }} />

          <Box sx={{ position: 'relative', zIndex: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
              <Box sx={{
                width: '2.5rem',
                height: '2.5rem',
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <CheckCircle sx={{ fontSize: 24, color: 'white' }} />
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1.3rem' }}>
                Credit Memo Progress
              </Typography>
            </Box>
            {selectedRowProgress && (
              <Typography variant="body2" sx={{ opacity: 0.9, fontSize: '0.9rem' }}>
                Application {selectedRowProgress.id} • {selectedRowProgress.borrowerName}
              </Typography>
            )}
          </Box>
        </Box>

        {selectedRowProgress && (
          <DialogContent sx={{ p: '2rem', backgroundColor: '#fafbfc' }}>
            {/* Progress Circle */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
              <Box sx={{ position: 'relative', width: '7.5rem', height: '7.5rem' }}>
                <CircularProgress
                  variant="determinate"
                  value={
                    selectedRowProgress.status === 'Rejected'
                      ? selectedRowProgress.creditMemoProgress || 100
                      : selectedRowProgress.creditMemoProgress || 0
                  }
                  size="7.5rem"
                  thickness={6}
                  sx={{
                    color: selectedRowProgress.status === 'Rejected'
                      ? '#F11D28'
                      : selectedRowProgress.creditMemoProgress >= 100
                        ? '#5ABA85'
                        : selectedRowProgress.creditMemoProgress >= 60
                          ? '#FFA12C'
                          : selectedRowProgress.creditMemoProgress >= 50
                            ? '#FF872C'
                            : selectedRowProgress.creditMemoProgress >= 25
                              ? '#FE612C'
                              : selectedRowProgress.creditMemoProgress >= 10
                                ? '#FD3A2D'
                                : '#F11D28',
                    position: 'absolute',
                    '& .MuiCircularProgress-circle': {
                      strokeLinecap: 'round',
                    }
                  }}
                />
                <Box sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  textAlign: 'center'
                }}>
                  <Typography variant="h5" sx={{
                    fontWeight: 700,
                    color: '#034A7F',
                    lineHeight: 1
                  }}>
                    {selectedRowProgress.creditMemoProgress || 0}%
                  </Typography>
                  <Typography variant="caption" sx={{
                    color: '#666',
                    fontSize: '0.7rem',
                    fontWeight: 500
                  }}>
                    Complete
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Status Card */}
            <Box sx={{
              backgroundColor: 'white',
              borderRadius: '0.75rem',
              p: '1.5rem',
              mb: '1.5rem',
              boxShadow: '0 0.25rem 1.25rem rgba(0,0,0,0.08)', // Converted from 4px 20px
              border: '0.0625rem solid rgba(0,0,0,0.05)' // Converted from 1px
            }}>
              <Typography variant="subtitle2" sx={{
                color: '#666',
                mb: 2,
                fontWeight: 600,
                fontSize: '0.85rem',
                textTransform: 'uppercase',
                letterSpacing: 0.5
              }}>
                Current Status
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Chip
                  label={selectedRowProgress.status}
                  color={selectedRowProgress.status === 'Approved' ? undefined : getStatusColor(selectedRowProgress.status)}
                  sx={{
                    fontWeight: 700,
                    fontSize: '0.9rem',
                    height: '2rem',
                    borderRadius: '0.5rem',
                    ...(selectedRowProgress.status === 'Approved' && {
                      backgroundColor: '#5ABA85',
                      color: 'white'
                    }),
                    ...(selectedRowProgress.status === 'Pending Approval' && {
                      backgroundColor: '#FFA12C',
                      color: 'white'
                    })
                  }}
                />
                <Box sx={{ ml: 'auto' }}>
                  <Typography variant="caption" sx={{
                    color: '#999',
                    fontSize: '0.75rem'
                  }}>
                    Last Updated: {selectedRowProgress.createdDate}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Progress Steps */}
            <Box sx={{
              backgroundColor: 'white',
              borderRadius: '0.75rem',
              p: '1.5rem',
              boxShadow: '0 0.25rem 1.25rem rgba(0,0,0,0.08)', // Converted from 4px 20px
              border: '0.0625rem solid rgba(0,0,0,0.05)' // Converted from 1px
            }}>
              <Typography variant="subtitle2" sx={{
                color: '#666',
                mb: 2,
                fontWeight: 600,
                fontSize: '0.85rem',
                textTransform: 'uppercase',
                letterSpacing: 0.5
              }}>
                Progress Breakdown
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                {[
                  { step: 'Document Review', progress: Math.min((selectedRowProgress.creditMemoProgress || 0) * 0.4, 100) },
                  { step: 'Credit Analysis', progress: Math.min((selectedRowProgress.creditMemoProgress || 0) * 0.7, 100) },
                  { step: 'Final Approval', progress: selectedRowProgress.creditMemoProgress || 0 }
                ].map((item, index) => (
                  <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <Box sx={{
                      width: '0.5rem',
                      height: '0.5rem',
                      borderRadius: '50%',
                      backgroundColor: item.progress === 100 ? '#5ABA85' : '#e0e0e0',
                      flexShrink: 0
                    }} />
                    <Typography variant="body2" sx={{
                      color: '#333',
                      fontWeight: 500,
                      minWidth: '7.5rem',
                      fontSize: '0.85rem'
                    }}>
                      {item.step}
                    </Typography>
                    <LinearProgress
                      variant="determinate"
                      value={item.progress}
                      sx={{
                        flexGrow: 1,
                        height: '0.375rem',
                        borderRadius: '0.75rem',
                        backgroundColor: '#f0f0f0',
                        '& .MuiLinearProgress-bar': {
                          backgroundColor: item.progress === 100 ? '#5ABA85' : '#034A7F',
                          borderRadius: '0.75rem'
                        }
                      }}
                    />
                    <Typography variant="caption" sx={{
                      color: '#666',
                      minWidth: '2.1875rem',
                      textAlign: 'right',
                      fontSize: '0.75rem',
                      fontWeight: 600
                    }}>
                      {Math.round(item.progress)}%
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </DialogContent>
        )}

        <DialogActions sx={{ p: '1.5rem', backgroundColor: '#fafbfc', borderTop: '0.0625rem solid rgba(0,0,0,0.05)' }}>
          <Button
            onClick={() => setShowProgressModal(false)}
            sx={{
              borderRadius: "2rem",
              textTransform: "none",
              px: '2rem',
              py: '0.5rem',
              backgroundColor: '#034A7F',
              color: 'white',
              fontWeight: 600,
              fontSize: '0.9rem',
              boxShadow: '0 0.25rem 0.9375rem rgba(3, 74, 127, 0.3)',
              '&:hover': {
                backgroundColor: '#023a66',
                boxShadow: '0 0.375rem 1.25rem rgba(3, 74, 127, 0.4)',
                transform: 'translateY(-0.0625rem)'
              },
              transition: 'all 0.2s ease-in-out'
            }}
          >
            Got it!
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: "0 0.5rem 1.5rem rgba(0,0,0,0.2)"
          }
        }}
      >
        {/* Title */}
        <DialogTitle
          sx={{
            fontSize: "1.1rem",
            fontWeight: 600,
            color: "#034A7F",
            pb: 1
          }}
        >
          Create a new application
        </DialogTitle>

        {/* Subtitle */}
        <DialogContent sx={{ textAlign: "left", pt: 0 }}>
          {!showCompletionUI && !showSuccessUI ? (
            <>
              <Typography variant="body2" sx={{ color: "#000000ff", mb: 3 }}>
                Add your documents here, and you can upload zip folder
              </Typography>

              {/* Upload Box */}
              <Box sx={{ border: "0.125rem dashed #C9D4E0", borderRadius: 2, p: 4, textAlign: "center", mb: 3, backgroundColor: "#FAFAFA" }}>
                <CloudUpload sx={{ fontSize: 50, color: "#034A7F", mb: 2 }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Drag your folder(s) or ZIP file to start uploading
                </Typography>

                <Typography variant="body2" color="text.secondary" sx={{ my: 1 }}>
                  OR
                </Typography>

                <Button variant="outlined" component="label" sx={{ borderRadius: "0.75rem", textTransform: "none", fontWeight: 600, borderColor: "#034A7F", color: "#034A7F", px: 3 }}>
                  Browse folder
                  <input type="file" hidden multiple onChange={handleFileUpload} accept=".zip" />
                </Button>
              </Box>

              {/* Note */}
              <Typography
                variant="caption"
                display="block"
                sx={{ mt: 2, color: "#6B6B6B" }}
              >
                Folders, ZIP files containing .pdf/.xlsx files are supported
              </Typography>

              {/* Uploaded Files */}
              {uploadedFiles.length > 0 && (
                <List sx={{ mt: 2, maxHeight: 400, overflow: 'auto' }}>
                  {uploadedFiles.map((file, index) => (
                    <ListItem
                      key={file.id}
                      sx={{
                        border: "0.0625rem solid #E0E0E0",
                        borderRadius: "0.75rem",
                        mb: 1,
                        px: 2,
                        backgroundColor: file.status === 'uploading' ? '#E3F2FD' :
                          file.status === 'completed' ? '#E8F5E8' : '#fff',
                        transition: 'all 0.3s ease',
                        transform: currentUploadIndex === index && file.status === 'uploading' ?
                          'scale(1.02)' : 'scale(1)',
                        boxShadow: currentUploadIndex === index && file.status === 'uploading' ?
                          '0 0.25rem 0.75rem rgba(33, 150, 243, 0.3)' : 'none'
                      }}
                      secondaryAction={
                        !isUploading && (
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => handleRemoveFile(index)}
                          >
                            <Cancel sx={{ color: "#C7C7C7" }} />
                          </IconButton>
                        )
                      }
                    >
                      {/* File Icon */}
                      <Avatar
                        variant="square"
                        sx={{
                          bgcolor: file.status === 'completed' ? "#5ABA85" :
                            file.status === 'uploading' ? "#034A7F" : "#FFE082",
                          color: file.status === 'completed' || file.status === 'uploading' ? "white" : "#034A7F",
                          width: 36,
                          height: 36,
                          mr: 2
                        }}
                      >
                        {file.status === 'completed' ? (
                          <CheckCircle />
                        ) : file.status === 'uploading' ? (
                          <Upload />
                        ) : (
                          <InsertDriveFileIcon />
                        )}
                      </Avatar>

                      {/* File Details */}
                      <ListItemText
                        primary={
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <Typography sx={{ fontSize: "0.9rem", fontWeight: 500 }}>
                                {file.name}
                              </Typography>
                              {file.status === 'uploading' && (
                                <CircularProgress size={16} />
                              )}
                              {file.status === 'completed' && (
                                <CheckCircle sx={{ color: '#5ABA85', fontSize: 16 }} />
                              )}
                            </Box>

                            {/* Upload Progress Bar */}
                            {file.status === 'uploading' && (
                              <Box sx={{ width: '100%', mt: 0.5 }}>
                                <LinearProgress
                                  variant="determinate"
                                  value={uploadProgress[file.id] || 0}
                                  sx={{ height: 4, borderRadius: 2 }}
                                />
                                <Typography variant="caption" sx={{ color: "#034A7F", fontWeight: 500, fontSize: '0.7rem' }}>
                                  Uploading... {Math.round(uploadProgress[file.id] || 0)}%
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        }
                        secondary={
                          file.status === 'completed' ? (
                            <Typography variant="caption" sx={{ color: "#5ABA85", fontWeight: 600 }}>
                              Uploaded Successfully
                            </Typography>
                          ) : file.status === 'uploading' ? null : (
                            <Typography variant="caption" sx={{ color: "#666" }}>
                              {`${(file.size / 1024 / 1024).toFixed(1)} MB`}
                            </Typography>
                          )
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              )}
            </>
          ) : showCompletionUI ? (
            /* Completion UI */
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                py: 6,
                px: 3
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  color: "#1E1E1E",
                  mb: 1
                }}
              >
                Analyzing document data, please wait...
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: "#666",
                  mb: 4,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}
              >
                {Math.round(completionProgress)}% • {Math.ceil((100 - completionProgress) * 1.8)} seconds remaining
              </Typography>

              {/* Progress Bar */}
              <Box sx={{ width: '100%', maxWidth: 400, mb: 3 }}>
                <LinearProgress
                  variant="determinate"
                  value={completionProgress}
                  sx={{
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: '#E3F2FD',
                    '& .MuiLinearProgress-bar': {
                      backgroundColor: '#034A7F',
                      borderRadius: 4
                    }
                  }}
                />
              </Box>
            </Box>
          ) : (
            /* Success UI - "All Set!" */
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                py: 6,
                px: 4,
                position: 'relative'
              }}
            >
              {/* Close button */}
              <IconButton
                onClick={handleCloseDialog}
                sx={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  color: '#999'
                }}
              >
                <Close />
              </IconButton>

              {/* Success Icon */}
              <Box
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  backgroundColor: '#5ABA85',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 3,

                }}
              >
                <CheckCircle
                  sx={{
                    fontSize: 40,
                    color: 'white'
                  }}
                />
              </Box>

              {/* Success Title */}
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 600,
                  color: "#1E1E1E",
                  mb: 2,
                  fontSize: '2rem'
                }}
              >
                All Set!
              </Typography>

              {/* Success Message */}
              <Typography
                variant="body1"
                sx={{
                  color: "#034A7F",
                  mb: 4,
                  fontSize: '1rem'
                }}
              >
                All files have been uploaded successfully and new applicaton has been created.
              </Typography>

              {/* Go Back Button */}
              <Button
                variant="contained"
                onClick={handleCloseDialog}
                sx={{
                  borderRadius: "0.5rem",
                  textTransform: "none",
                  px: 6,
                  py: 1.5,
                  backgroundColor: "#034A7F",
                  fontWeight: 600,
                  fontSize: '1rem',
                  minWidth: 200,
                  "&:hover": {
                    backgroundColor: "#034A7F"
                  }
                }}
              >
                Close
              </Button>
            </Box>
          )}
        </DialogContent>

        {/* Actions */}
        {!showCompletionUI && !showSuccessUI && (
          <DialogActions sx={{ px: 3, pb: 3 }}>
            <Button
              onClick={handleCloseDialog}
              disabled={isUploading}
              sx={{
                borderRadius: "0.5rem",
                textTransform: "none",
                px: 3,
                color: "#4A4A4A",
                border: "0.0625rem solid #C7C7C7",
                backgroundColor: "#C7C7C7",
                "&:hover": {
                  backgroundColor: "#EAEAEA"
                },
                "&:disabled": {
                  backgroundColor: "#F0F0F0",
                  color: "#999"
                }
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleStartUpload}
              disabled={uploadedFiles.length === 0 || isUploading}
              startIcon={isUploading ? <CircularProgress size={16} color="inherit" /> : null}
              sx={{
                borderRadius: "0.5rem",
                textTransform: "none",
                px: 3,
                backgroundColor: "#034A7F",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "#034A7F"
                },
                "&:disabled": {
                  backgroundColor: "#C7C7C7",
                  color: "#999"
                }
              }}
            >
              {isUploading ? 'Uploading...' : 'Next'}
            </Button>
          </DialogActions>
        )}
      </Dialog>
      {/* Validation Error Dialog */}
      <Dialog
          open={showValidationDialog}
          onClose={() => setShowValidationDialog(false)}
          maxWidth={false}
          PaperProps={{
              sx: {
                  borderRadius: 2,
                  boxShadow: "0 0.5rem 1.5rem rgba(0,0,0,0.2)",
                  width: { xs: '95%', sm: '90%', md: '85%', lg: '75%', xl: '65%' },
                  maxWidth: '68.75rem',
                  m: 2
              }
          }}
      >
          <DialogTitle
              sx={{
                  fontSize: { xs: '1rem', sm: '1.1rem' },
                  fontWeight: 600,
                  color: "#F11D28",
                  py: { xs: 1, sm: 1.5 },
                  px: { xs: 2, sm: 3 }
              }}
          >
              File Validation Failed
          </DialogTitle>

          <DialogContent sx={{ pt: 1, px: { xs: 2, sm: 3 } }}>
              <Typography variant="body2" sx={{ mb: 2, color: "#666", fontSize: { xs: '0.813rem', sm: '0.875rem' } }}>
                  The uploaded ZIP folder contains errors. Please fix the following issues and try again:
              </Typography>

              {/* Summary Box - Compact */}
              <Box sx={{ 
                  p: 1.5, 
                  backgroundColor: "#fff5f5", 
                  borderRadius: "0.5rem",
                  border: "0.0625rem solid #ffebee",
                  mb: 2
              }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#F11D28", mb: 0.5, fontSize: '0.875rem' }}>
                      Summary
                  </Typography>
                  {validationErrors.map((error, index) => {
                      if (error.type === 'count') {
                          return (
                              <Typography key={index} variant="body2" sx={{ color: "#666", fontSize: '0.75rem' }}>
                                  • {error.message}
                              </Typography>
                          );
                      } else if (error.type === 'file') {
                          return (
                              <Typography key={index} variant="body2" sx={{ color: "#666", fontSize: '0.75rem' }}>
                                  • Extra file: <strong>{error.fileName}</strong> - Not required. Please remove it.
                              </Typography>
                          );
                      } else if (error.type === 'missing') {
                          return (
                              <Typography key={index} variant="body2" sx={{ color: "#666", fontSize: '0.75rem' }}>
                                  • {error.message}
                              </Typography>
                          );
                      }
                      return null;
                  })}
              </Box>

              {/* 2-Column Layout for Files */}
              <Box sx={{ 
                  display: 'grid', 
                  gridTemplateColumns: { xs: '1fr', sm: '1fr', md: '1fr 1fr' }, 
                  gap: 2 
              }}>
                  {/* Left Column - First 11 files */}
                  <Box sx={{ 
                      border: "1px solid #e0e0e0", 
                      borderRadius: "0.5rem", 
                      overflow: "hidden"
                  }}>
                      <Box sx={{ 
                          display: 'grid', 
                          gridTemplateColumns: '1fr 1fr 50px',
                          backgroundColor: "#f5f5f5",
                          borderBottom: "1px solid #e0e0e0"
                      }}>
                          <Box sx={{ p: 1, borderRight: "1px solid #e0e0e0" }}>
                              <Typography variant="caption" sx={{ fontWeight: 700, color: "#034A7F", fontSize: '0.75rem' }}>
                                  Expected
                              </Typography>
                          </Box>
                          <Box sx={{ p: 1, borderRight: "1px solid #e0e0e0" }}>
                              <Typography variant="caption" sx={{ fontWeight: 700, color: "#034A7F", fontSize: '0.75rem' }}>
                                  Uploaded
                              </Typography>
                          </Box>
                          <Box sx={{ p: 1, textAlign: 'center' }}>
                              <Typography variant="caption" sx={{ fontWeight: 700, color: "#034A7F", fontSize: '0.75rem' }}>
                                  ✓
                              </Typography>
                          </Box>
                      </Box>
                      {[
                          '2022_BS.pdf', '2022_PL.pdf', '2023_BS.pdf', '2023_PL.pdf', '2024_BS.pdf', '2024_PL.pdf',
                          'CO1_2022_ITR.pdf', 'CO1_2023_ITR.pdf', 'CO1_AADHAR.pdf', 'CO1_CIBIL.pdf', 'CO1_PAN.pdf'
                      ].map((expectedFile, idx) => {
                          const uploadedFiles = validationErrors.find(e => e.uploadedFiles)?.uploadedFiles || [];
                          const isUploaded = uploadedFiles.includes(expectedFile);
                          
                          return (
                              <Box 
                                  key={idx}
                                  sx={{ 
                                      display: 'grid', 
                                      gridTemplateColumns: '1fr 1fr 50px',
                                      borderBottom: idx < 10 ? "1px solid #f0f0f0" : "none",
                                      backgroundColor: idx % 2 === 0 ? "#fafafa" : "#fff"
                                  }}
                              >
                                  <Box sx={{ p: 0.75, borderRight: "1px solid #f0f0f0" }}>
                                      <Typography variant="body2" sx={{ fontSize: '0.7rem', color: "#333" }}>
                                          {expectedFile}
                                      </Typography>
                                  </Box>
                                  <Box sx={{ p: 0.75, borderRight: "1px solid #f0f0f0" }}>
                                      <Typography variant="body2" sx={{ fontSize: '0.7rem', color: isUploaded ? "#5ABA85" : "#999" }}>
                                          {isUploaded ? expectedFile : '-'}
                                      </Typography>
                                  </Box>
                                  <Box sx={{ p: 0.75, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                      {isUploaded ? (
                                          <CheckCircle sx={{ fontSize: 16, color: "#5ABA85" }} />
                                      ) : (
                                          <Cancel sx={{ fontSize: 16, color: "#F11D28" }} />
                                      )}
                                  </Box>
                              </Box>
                          );
                      })}
                  </Box>

                  {/* Right Column - Last 11 files */}
                  <Box sx={{ 
                      border: "1px solid #e0e0e0", 
                      borderRadius: "0.5rem", 
                      overflow: "hidden"
                  }}>
                      <Box sx={{ 
                          display: 'grid', 
                          gridTemplateColumns: '1fr 1fr 50px',
                          backgroundColor: "#f5f5f5",
                          borderBottom: "1px solid #e0e0e0"
                      }}>
                          <Box sx={{ p: 1, borderRight: "1px solid #e0e0e0" }}>
                              <Typography variant="caption" sx={{ fontWeight: 700, color: "#034A7F", fontSize: '0.75rem' }}>
                                  Expected
                              </Typography>
                          </Box>
                          <Box sx={{ p: 1, borderRight: "1px solid #e0e0e0" }}>
                              <Typography variant="caption" sx={{ fontWeight: 700, color: "#034A7F", fontSize: '0.75rem' }}>
                                  Uploaded
                              </Typography>
                          </Box>
                          <Box sx={{ p: 1, textAlign: 'center' }}>
                              <Typography variant="caption" sx={{ fontWeight: 700, color: "#034A7F", fontSize: '0.75rem' }}>
                                  ✓
                              </Typography>
                          </Box>
                      </Box>
                      {[
                          'COM_BANK_Summary.xlsx', 'COM_CIBIL.pdf', 'COM_GST_Certificate.pdf', 'COM_LOAN_Application.pdf', 'COM_UDYAM_Certificate.pdf',
                          'PR_2022_ITR.pdf', 'PR_2023_ITR.pdf', 'PR_AADHAR.pdf', 'PR_CIBIL.pdf', 'PR_NETWORTH.pdf', 'PR_PAN.pdf'
                      ].map((expectedFile, idx) => {
                          const uploadedFiles = validationErrors.find(e => e.uploadedFiles)?.uploadedFiles || [];
                          const isUploaded = uploadedFiles.includes(expectedFile);
                          
                          return (
                              <Box 
                                  key={idx}
                                  sx={{ 
                                      display: 'grid', 
                                      gridTemplateColumns: '1fr 1fr 50px',
                                      borderBottom: idx < 10 ? "1px solid #f0f0f0" : "none",
                                      backgroundColor: idx % 2 === 0 ? "#fafafa" : "#fff"
                                  }}
                              >
                                  <Box sx={{ p: 0.75, borderRight: "1px solid #f0f0f0" }}>
                                      <Typography variant="body2" sx={{ fontSize: '0.7rem', color: "#333" }}>
                                          {expectedFile}
                                      </Typography>
                                  </Box>
                                  <Box sx={{ p: 0.75, borderRight: "1px solid #f0f0f0" }}>
                                      <Typography variant="body2" sx={{ fontSize: '0.7rem', color: isUploaded ? "#5ABA85" : "#999" }}>
                                          {isUploaded ? expectedFile : '-'}
                                      </Typography>
                                  </Box>
                                  <Box sx={{ p: 0.75, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                      {isUploaded ? (
                                          <CheckCircle sx={{ fontSize: 16, color: "#5ABA85" }} />
                                      ) : (
                                          <Cancel sx={{ fontSize: 16, color: "#F11D28" }} />
                                      )}
                                  </Box>
                              </Box>
                          );
                      })}
                  </Box>
              </Box>
          </DialogContent>

          <DialogActions sx={{ px: { xs: 2, sm: 3 }, py: 2 }}>
              <Button
                  onClick={() => {
                      setShowValidationDialog(false);
                      setValidationErrors([]);
                      setUploadedFiles([]);
                  }}
                  variant="contained"
                  fullWidth
                  sx={{
                      borderRadius: "0.5rem",
                      textTransform: "none",
                      px: 3,
                      py: 0.75,
                      fontSize: { xs: '0.813rem', sm: '0.875rem' },
                      backgroundColor: "#034A7F",
                      fontWeight: 600,
                      maxWidth: { xs: '100%', sm: '15.625rem' },
                      "&:hover": {
                          backgroundColor: "#023a66"
                      }
                  }}
              >
                  Got it, I'll fix the files
              </Button>
          </DialogActions>
      </Dialog>


    </Box>
  );
};
export default Home;